import { PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var StatusApprovalsPipe = /** @class */ (function () {
    function StatusApprovalsPipe(translateService, fuseTranslationLoaderService) {
        this.translateService = translateService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    StatusApprovalsPipe.prototype.transform = function (statusName) {
        if (statusName) {
            if (statusName === 'pending') {
                return this.translateService.instant('APPROVALS_STATUS.PENDING');
            }
            else if (statusName === 'approved') {
                return this.translateService.instant('APPROVALS_STATUS.APPROVED');
            }
            else if (statusName === 'refused') {
                return this.translateService.instant('APPROVALS_STATUS.REFUSED');
            }
            else if (statusName === 'canceled') {
                return this.translateService.instant('APPROVALS_STATUS.CANCELED');
            }
        }
        return null;
    };
    return StatusApprovalsPipe;
}());
export { StatusApprovalsPipe };
